import { createAsyncThunk } from "@reduxjs/toolkit";
import { nodeRpc } from "api";
import { AsyncResourceRequest } from "common/common.types";

export interface NodeRequest {
  siteId: string;
  namespace: string;
  resourceId: string;
  nodeName: string;
}

export const fetchNodeList = createAsyncThunk(
  "nodes/fetchNodeList",
  async (req: AsyncResourceRequest, { rejectWithValue, getState }) => {
    return nodeRpc.api
      .getNodeList(req.siteId, req.namespace)
      .then((res: any) => {
        if (res.data !== undefined) {
          return res.data.nodes;
        }
      })
      .catch((err: any) => {
        return rejectWithValue(err);
      });
  },
);

export const fetchNodeEvents = createAsyncThunk(
  "nodes/fetchNodeEvents",
  async (req: NodeRequest, { rejectWithValue, getState }) => {
    return nodeRpc.api
      .getNodeEvents(req.siteId, req.namespace, req.nodeName)
      .then((res: any) => {
        if (res.data !== undefined) {
          return res.data;
        }
      })
      .catch((err: any) => {
        return rejectWithValue(err);
      });
  },
);

export const fetchNodeDescribe = createAsyncThunk(
  "nodes/fetchNodeDescribe",
  async (req: NodeRequest, { rejectWithValue, getState }) => {
    return nodeRpc.api
      .getNodeDescribe(req.siteId, req.namespace, req.nodeName)
      .then((res: any) => {
        if (res.data !== undefined) {
          return res.data;
        }
      })
      .catch((err: any) => {
        return rejectWithValue(err);
      });
  },
);
